import { render } from "./ModalRemovePdfTemplate.vue?vue&type=template&id=26f30110"
import script from "./ModalRemovePdfTemplate.vue?vue&type=script&lang=js"
export * from "./ModalRemovePdfTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__